/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IVideoPlayerModalScope extends ng.IScope {
        streamURL: string;
        live: boolean;
        blockId: string;
        videoFeed: Models.VideoFeed;
        modalClose: () => void;
        onVideoPlayError: () => void;
    }

    /**
     * VideoPlayerModalController class
     */
    export class VideoPlayerModalController {
        public static templateUrl: string = "decorators/modals/video-player-modal.html";
        public static ID: string = "#id-video-player-modal";
        public static $name: string = "videoPlayerModalController";
        public static $inject: string[] = ['$scope', 'videoFeedService', 'close', 'streamURL', 'live', 'blockId', 'videoFeed'];

        private scope: IVideoPlayerModalScope;
        private videoFeedService: Services.VideoFeedService;
        private close: () => void;

        /**
         * Constructor
         */
        constructor($scope: IVideoPlayerModalScope, videoFeedService: Services.VideoFeedService, close: () => void, 
                    streamURL: string, live: boolean, blockId: string, videoFeed: Models.VideoFeed) {
            this.scope = $scope;
            this.videoFeedService = videoFeedService;
            this.close = close;
            this.scope.streamURL = streamURL;
            this.scope.live = live;
            this.scope.blockId = blockId;
            this.scope.videoFeed = videoFeed;

            this.scope.modalClose = (): void => {
                this.close();
            };

            this.scope.onVideoPlayError = (): void => {
                if (this.scope.blockId !== undefined && this.scope.videoFeed !== undefined) {
                    this.videoFeedService.notifyVideoPlayErrorByBlockId(this.scope.blockId, this.scope.videoFeed);
                }
            };
        }
    }
}
